import { render, staticRenderFns } from "./appointments-new.vue?vue&type=template&id=76bddc62&scoped=true&"
import script from "./appointments-new.vue?vue&type=script&lang=js&"
export * from "./appointments-new.vue?vue&type=script&lang=js&"
import style0 from "@/assets/table-styling.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./appointments-new.vue?vue&type=style&index=1&id=76bddc62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bddc62",
  null
  
)

component.options.__file = "appointments-new.vue"
export default component.exports